import { render, staticRenderFns } from "./AddEditSectionModal.vue?vue&type=template&id=415d05da&"
import script from "./AddEditSectionModal.vue?vue&type=script&lang=js&"
export * from "./AddEditSectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports